<template>
  <div class="d-flex mt-2">
    <div
      v-for="s in sentiments"
      :key="s"
      class="d-flex align-center ml-4"
      style="cursor: pointer"
      :style="{ opacity: getOpacity(s) }"
      @click="$emit('toggle', s)"
    >
      <div
        style="width:16px; height:16px;"
        :style="{ background: color(s) }"
        class="mr-2"
      ></div>
      <div class="text-capitalize">{{ s }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sentiments: {
      type: Array,
      required: true
    },
    getOpacity: {
      type: Function,
      required: true
    },
    color: {
      type: Function,
      required: true
    }
  }
};
</script>
